var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCalendarTodayOutlined(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17 5C18.2632 5 19 5.73684 19 7H5C5 5.73684 5.73684 5 7 5H17ZM17 3H7C4.75439 3 3 4.75439 3 7V9H21V7C21 4.75439 19.2456 3 17 3ZM5 9H19V17C19 18.2632 18.2632 19 17 19H7C5.73684 19 5 18.2632 5 17V9ZM3 7V17C3 19.2456 4.75439 21 7 21H17C19.2456 21 21 19.2456 21 17V7H3ZM6 2V4C6 4.54386 6.45614 5 7 5C7.54386 5 8 4.54386 8 4V2C8 1.45614 7.54386 1 7 1C6.45614 1 6 1.45614 6 2ZM18 4V2C18 1.45614 17.5439 1 17 1C16.4561 1 16 1.45614 16 2V4C16 4.54386 16.4561 5 17 5C17.5439 5 18 4.54386 18 4Z",
    fill: "currentColor"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendarTodayOutlined);
export default __webpack_public_path__ + "static/media/calendar_today_outlined.bfc79428.svg";
export { ForwardRef as ReactComponent };